module.exports = __webpack_public_path__ + "media/common/calendar_leads-86c68cb5.png";